import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import { Modal, Button } from 'react-bootstrap';
import cx from 'classnames';

// Redux
import { connect } from 'react-redux';
import { closeWishListGroupModal } from '../../../actions/WishList/modalActions';
import { deleteWishListGroup } from '../../../actions/WishList/deleteWishListGroup';

// Translation
import { FormattedMessage, injectIntl } from 'react-intl';

// Locale
import messages from '../../../locale/jsonMessages';

// Components
import AddWishListGroupForm from '../WishListGroupForm/AddWishListGroupForm';
import EditWishListGroupForm from '../EditWishListGroupForm';

import cs from '../../../components/commonStyle.css';
import s from './WishListGroupModal.css';

const WishListGroupModal = (props) => {
  const { wishListGroupModal, closeWishListGroupModal, deleteWishListGroup, wishListGroupId, actionType, intl: { formatMessage } } = props
  const [wishListGroupModalStatus, setWishListGroupModalStatus] = useState(false);

  useEffect(() => {
    if (wishListGroupModal === true) {
      setWishListGroupModalStatus(true);
    }
  }, []);

  useEffect(() => {
    setWishListGroupModalStatus(wishListGroupModal === true);
  }, [wishListGroupModal]);

  const closeWishListModal = () => {
    closeWishListGroupModal();
    const root = document.getElementsByTagName('html')[0];
    root.classList.remove('scrollHidden');
  };

  const deleteWishList = () => {
    deleteWishListGroup(wishListGroupId);
    closeWishListModal();
  };

  useEffect(() => {
    return () => {
      closeWishListModal();
    };
  }, []);

  return (
    <Modal
      show={wishListGroupModalStatus}
      onHide={closeWishListModal}
      dialogClassName='commonModalContainer whistListModalContainer'
    >
      <Modal.Header closeButton className='commonModalHeader'>
        <Modal.Title className='commonModalTitle'>
          {actionType === 'edit' ? (
            <FormattedMessage {...messages.wishLists} />
          ) : actionType === 'add' ? (
            <FormattedMessage {...messages.newWishList} />
          ) : (
            <FormattedMessage {...messages.deleteWishList} />
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body bsClass='commonModalBody'>
        {actionType === 'add' ? (
          <AddWishListGroupForm closeModal={closeWishListModal} />
        ) : actionType === 'edit' ? (
          <EditWishListGroupForm closeModal={closeWishListModal} />
        ) : (
          <div>
            <div className={cx(cs.commonContentText, cs.fontWeightMedium)}>
              <FormattedMessage {...messages.areYouSureDeleteWishList} />
            </div>
            <div className={cx('doubleBtnFlexEnd', cs.spaceTop4)}>
              <Button className={cs.btnPrimaryBorder} onClick={closeWishListModal}>
                {formatMessage(messages.cancel)}
              </Button>
              <Button
                className={cs.btnPrimary}
                onClick={deleteWishList}
              >
                {formatMessage(messages.confirmDelete)}
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

WishListGroupModal.propTypes = {
  closeWishListGroupModal: PropTypes.func,
  deleteWishListGroup: PropTypes.func,
  wishListGroupId: PropTypes.any,
  wishListGroupModal: PropTypes.bool,
  actionType: PropTypes.string,
  intl: PropTypes.object
};

const mapState = (state) => ({
  wishListGroupModal: state.modalStatus.wishListGroupModalOpen,
});

const mapDispatch = {
  closeWishListGroupModal,
  deleteWishListGroup
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(WishListGroupModal)));
